// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"70":"8a1c4e89ed7af4b8","563":"24b37456994eef2d","811":"52f7165cc5fe5c8e","942":"1d1e09129ec5f2fe"}[chunkId] + ".js";
};